import './Footer.css';

const Footer = () => {

    return (
        <footer>
            <p>&copy; 2024 All rights deserved. Tony Cars P.IVA 13117620016</p>
        </footer>
    );

}

export default Footer;